import { PluginFunc } from 'dayjs';
import { isNullOrEmpty } from './utils';

const dayjsCustomRelative: PluginFunc = (_opts, dayjsClass, dayjsFactory) => {
  const oldFromNow = dayjsClass.prototype.fromNow;

  dayjsClass.prototype.fromNow = function (withoutSuffix) {
    const now = dayjsFactory();
    const diffInDays = now.diff(this, 'day');
    if (diffInDays === 1 || diffInDays === 0) {
      const locale = this.locale();
      const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
      return rtf.format(-diffInDays, 'day');
    }
    return oldFromNow.call(this, withoutSuffix);
  };
}

export default dayjsCustomRelative;